import React from 'react';
import Button, { ButtonTypeEnum } from 'ui/Button/Button';
import ShoppingListIcon from '@ingka/ssr-icon/paths/document-pencil';
import ShoppingBagIcon from '@ingka/ssr-icon/paths/shopping-bag';

import styled from 'styled-components';
import { isKiosk } from 'utils/platform';
import { getKioskIntegration } from 'utils/integration';
import { useServiceSettings } from 'contexts/serviceSettings';

const Wrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

const ShoppingButton = ({
  hidden,
  ssrIcon,
  link,
  label,
  onClick
}: {
  hidden: boolean;
  ssrIcon?: (...args: any[]) => any;
  link: string;
  label: string;
  onClick: () => void;
}) => {
  return (
    <a hidden={hidden || isKiosk()} rel="noopener noreferrer" target="_blank" href={link}>
      <Button
        aria-label={label}
        ssrIcon={ssrIcon}
        iconOnly
        type={ButtonTypeEnum.tertiary}
        onClick={onClick}
      />
    </a>
  );
};

const ShoppingButtons = () => {
  const {
    dexfSettings: {
      kompis: {
        urls: { shoppingCartLink, shoppingListLink }
      }
    },
    services: { shoppingCartSupported, shoppingListSupported }
  } = useServiceSettings();
  const kioskIntegration = getKioskIntegration();

  return (
    <Wrapper>
      <ShoppingButton
        hidden={!shoppingListSupported}
        ssrIcon={ShoppingListIcon}
        link={shoppingListLink}
        label="shopping-list"
        onClick={() => kioskIntegration.shoppingListClicked()}
      />
      <ShoppingButton
        hidden={!shoppingCartSupported}
        ssrIcon={ShoppingBagIcon}
        link={shoppingCartLink}
        label="shopping-bag"
        onClick={() => {}}
      />
    </Wrapper>
  );
};

export default ShoppingButtons;
